export enum IconType {
  GenAdBot = "genAdBot",
  ArrowDown = "arrowDown",
  ArrowDownToBracketThin = "arrowDownToBracketThin",
  ArrowUp = "arrowUp",
  ArrowUpFromBracketThin = "arrowUpFromBracketThin",
  ArrowUpRightFromSquare = "arrowUpRightFromSquare",
  BookSparkles = "bookSparkles",
  BarsFilter = "barsFilter",
  BoxArchive = "boxArchive",
  Bolt = "bolt",
  BoltLight = "boltLight",
  CalendarLight = "calendarLight",
  CaretDown = "caretDown",
  CartShopping = "cartShopping",
  CartShoppingRegular = "cartShoppingRegular",
  ChartLineUp = "chartLineUp",
  Check = "check",
  ChevronLeft = "chevronLeft",
  ChevronRight = "chevronRight",
  ChartUser1Duo = "chartUser1Duo",
  ChartMixed = "chartMixed",
  Circle = "circle",
  CircleArrowUp = "circleArrowUp",
  CircleCheck = "circleCheck",
  CircleCheckFilled = "circleCheckFilled",
  CircleCheckThick = "circleCheckThick",
  CircleDot = "circleDot",
  CircleExclamation = "CircleExclamation",
  CircleInfo = "circleInfo",
  CirclePlus = "circlePlus",
  CirclePlusThin = "circlePlusThin",
  CirclePlusFilled = "circlePlusFilled",
  CircleMinus = "circleMinus",
  CircleXMark = "circleXMark",
  CircleXMarkSolid = "circleXMarkSolid",
  Clipboard = "clipboard",
  ClipboardListCheckDuo = "clipboardListCheckDuo",
  Clone = "clone",
  Comment = "comment",
  CommentSlash = "commentSlash",
  CommentLines = "commentLines",
  Demote = "demote",
  DownToBracket = "downToBracket",
  EllipsisVertical = "ellipsisVertical",
  Empty = "empty",
  EmptyThin = "emptyThin",
  FileCSVLight = "fileCSVLight",
  FillDrip = "fillDrip",
  Gear = "gear",
  GDNColor = "GDNColor",
  GDNGray = "GDNGray",
  House = "house",
  ImagePolaroidDuo = "imagePolaroidDuo",
  LLight = "LLight",
  LayerGroup = "layerGroup",
  LightbulbOn = "lightbulbOn",
  LightbulbOnLight = "lightbulbOnLight",
  LineColumnsLight = "lineColumnsLight",
  Link = "link",
  Loading = "loading",
  Loader = "loader",
  MessageImageDuo = "MessageImageDuo",
  MessageImageLight = "MessageImageLight",
  MetaColor = "MetaColor",
  MetaGray = "MetaGray",
  Meta = "Meta",
  MoneyCheckPen = "MoneyCheckPen",
  MSANColor = "MSANColor",
  MSANGray = "MSANGray",
  PaintbrushPencil = "paintbrushPencil",
  Pencil = "pencil",
  PenCircleSolid = "penCircleSolid",
  PenToSquare = "penToSquare",
  Plus = "plus",
  PlusCustom = "plusCustom",
  RedoRegular = "redoRegular",
  ShieldHalved = "shieldHalved",
  Sliders = "sliders",
  Sparkles = "sparkles",
  SparklesDuo = "sparklesDuo",
  SquareMinus = "squareMinus",
  StarEmpty = "starEmpty",
  StarEmptyThin = "starEmptyThing",
  StarFilled = "starFilled",
  Text = "text",
  ThumbsUp = "thumbsUp",
  ThumbsDown = "thumbsDown",
  TrashCan = "trashCan",
  TrashUndo = "trashUndo",
  TriangleExclamation = "triangleExclamation",
  TrophyStar = "trophyStar",
  TrophyStarDuo = "trophyStarDuo",
  UpFromBracket = "upFromBracket",
  UndoRegular = "undoRegular",
  Video = "video",
  Xmark = "xmark",
  RadioSelected = "radioSelected",
  RadioUnselected = "radioUnselected"
}
